import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Filter, IRecEffFilter, EmptyRecEffFilter } from "./Filter";
import { SubTable } from "./SubTable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { SubTableEfficiencyReport } from "../SubTableEfficiencyReport";

interface IRecruiterEfficiency {
    login_ID?: number,
    recruiter?: string,
    branchName?: string,
    noOfSub?: number,
    noOfSubPV?: number,
    noOfSubClient?: number,
    noOfSubRejSales?: number,
    noOfSubRejPV?: number,
    noOfSubRejClient?: number,
    noOfECI?: number,
    noStatusNotChange?: number,
    noOfServe?: number,
    noOfUnServe?: number,
    noOfAllReq?: number,
    noOfReqHoldbyPV?: number,
    noOfNoRoomECS?: number,
}

export const RecruiterEfficiency = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRecruiterEfficiency>, loading: boolean });
    const [tFooter, setTFooter] = useState<IRecruiterEfficiency>({});
    const [salEffFilter, setSalEffFilter] = useState<IRecEffFilter>(EmptyRecEffFilter);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [tableLoad, setTableLoad] = useState(false);

    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const [filter, setFilter] = useState(false);
    const hideFilterDialog = () => {
        setFilter(false);
    };

    const [subTable, setSubTable] = useState({ open: false, salesID: 0, resType: 0, totalRec: null } as { open: boolean, salesID?: number, resType: number, totalRec?: boolean | null });
    const [subTable1, setSubTable1] = useState({ open: false, salesID: 0, resType: 0, totalRec: null } as { open: boolean, salesID?: number, resType: number, totalRec?: boolean | null });

    const hideSubTableDialog = () => {
        setSubTable({ open: false, salesID: 0, resType: 0, totalRec: null });
        setSubTable1({ open: false, salesID: 0, resType: 0, totalRec: null });
    };

    useEffect(() => {
        if (tableLoad) {
            setTableLoad(false);
            loadTableData();
        }
    }, [salEffFilter]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Recruiter_Efficiency", "GET", null, `filter=${JSON.stringify(salEffFilter)}`, toast);
        if (response) {
            const data: Array<IRecruiterEfficiency> = await response.json();

            const _data: Array<IRecruiterEfficiency> = [];
            let totalNoOfSub = 0;
            let totalNoOfSubPV = 0;
            let totalNoOfSubClient = 0;
            let totalNoOfSubRejSales = 0;
            let totalNoOfSubRejPV = 0;
            let totalNoOfSubRejClient = 0;
            let totalNoOfECI = 0;
            let totalNoStatusNotChange = 0;
            let totalNoOfServe = 0;
            let totalNoOfUnServe = 0;
            let totalNoOfAllReq = 0;
            data.forEach((d, i) => {
                if (d.noOfSub) totalNoOfSub += d.noOfSub;
                if (d.noOfSubPV) totalNoOfSubPV += d.noOfSubPV;
                if (d.noOfSubClient) totalNoOfSubClient += d.noOfSubClient;
                if (d.noOfSubRejSales) totalNoOfSubRejSales += d.noOfSubRejSales;
                if (d.noOfSubRejPV) totalNoOfSubRejPV += d.noOfSubRejPV;
                if (d.noOfSubRejClient) totalNoOfSubRejClient += d.noOfSubRejClient;
                if (d.noOfECI) totalNoOfECI += d.noOfECI;
                if (d.noStatusNotChange) totalNoStatusNotChange += d.noStatusNotChange;
                if (d.noOfServe) totalNoOfServe += d.noOfServe;
                if (d.noOfUnServe) totalNoOfUnServe += d.noOfUnServe;
                if (d.noOfAllReq) totalNoOfAllReq += d.noOfAllReq;
                _data.push(d);
            });
            const totalRecords: IRecruiterEfficiency = {
                recruiter: "Total Records",
                noOfSub: totalNoOfSub,
                noOfSubPV: totalNoOfSubPV,
                noOfSubClient: totalNoOfSubClient,
                noOfSubRejSales: totalNoOfSubRejSales,
                noOfSubRejPV: totalNoOfSubRejPV,
                noOfSubRejClient: totalNoOfSubRejClient,
                noOfECI: totalNoOfECI,
                noStatusNotChange: totalNoStatusNotChange,
                noOfServe: totalNoOfServe,
                noOfUnServe: totalNoOfUnServe,
                noOfAllReq: totalNoOfAllReq
            };
            setTFooter(totalRecords);

            setTableData({ tableData: _data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        return (
            permissions.is_Export || loginObj.is_Team_Lead ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Recruiter Efficiency Report</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const noOfSub = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 1 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSub}</span>
    const noOfSubPV = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 2 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubPV}</span>
    const noOfSubClient = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 3 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubClient}</span>
    const noOfSubRejSales = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 4 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubRejSales}</span>
    const noOfSubRejPV = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubRejPV}</span>
    const noOfSubRejClient = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 6 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubRejClient}</span>
    const noOfECI = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 7 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfECI}</span>
    const noStatusNotChange = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 8 })} className="cursor-pointer text-cyan-700 underline">{rowData.noStatusNotChange}</span>
    // const noOfServe = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 9 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfServe}</span>
    // const noOfUnServe = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 10 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfUnServe}</span>
    // const noOfAllReq = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 11 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfAllReq}</span>
    // const noOfServe = (rowData: IRecruiterEfficiency) => <span className="text-cyan-700 underline">{rowData.noOfServe}</span>
    // const noOfUnServe = (rowData: IRecruiterEfficiency) => <span className="text-cyan-700 underline">{rowData.noOfUnServe}</span>
    // const noOfAllReq = (rowData: IRecruiterEfficiency) => <span className="text-cyan-700 underline">{rowData.noOfAllReq}</span>
    // body={(rowData)=>(rowData.branchName ? rowData.branchName.split("(")[1].substring(0,4)+"("+rowData.branchName.split("(")[0] +")" : ""   )}
    const noOfAllReq = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 1 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfAllReq}</span>
    const noOfServe = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfServe}</span>
    const noOfUnServe = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 6 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfUnServe}</span>
    const noRoomForECS = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 14 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfNoRoomECS}</span>
    const reqHoldByPV = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 15 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfReqHoldbyPV}</span>

    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Report_Recruiter_Efficiency/getexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(salEffFilter)) + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `RecruiterEfficiencyReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salEffFilter={salEffFilter} setSalEffFilter={setSalEffFilter} downloadExcel={downloadExcel} excelLoading={excelLoading} onSearch={() => setTableLoad(true)}/>
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={tFooter.recruiter} />
                <Column field="recruiter" header="Recruiter" sortable body={(rowData) => <p style={{ color: rowData.user_Status ? "red" : "" }}>{rowData.recruiter.trim()}</p>} />
                <Column field="branchName" header="Recruiter Comp(Branch)" sortable />
                <Column field="teamManager" header="Team Manager" sortable />

                <Column field="noOfAllReq" header="#AllReq" sortable body={noOfAllReq} footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.noOfAllReq || 0), 0);
                    return <span
                        onClick={() => setSubTable({ open: true, resType: 1 })}
                        className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }} />
                <Column field="noOfServe" header="#Serve" sortable body={noOfServe} footer={() => {
                    const No_Serve = tableData.tableData.reduce((sum, item) => sum + (item.noOfServe || 0), 0);
                    return <span
                        onClick={() => setSubTable({ open: true, resType: 5 })}
                        className="cursor-pointer text-cyan-700 underline">{No_Serve}</span>;
                }} />
                <Column field="noOfUnServe" header="#UnServe" sortable body={noOfUnServe} footer={() => {
                    const UnServe = tableData.tableData.reduce((sum, item) => sum + (item.noOfUnServe || 0), 0);
                    return <span
                        onClick={() => setSubTable({ open: true, resType: 6, totalRec: true })}
                        className="cursor-pointer text-cyan-700 underline">{UnServe}</span>;
                }} />
                <Column field="noOfSub" header="#Sub" sortable body={noOfSub}
                    footer={() => {
                        const noOfSub = tableData.tableData.reduce((sum, item) => sum + (item.noOfSub || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 1, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{noOfSub}</span>;
                    }}
                />
                <Column field="noOfSubPV" header="#SubPV" sortable body={noOfSubPV}
                    footer={() => {
                        const NOSubPv = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubPV || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 2, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{NOSubPv}</span>;
                    }} />
                <Column field="noOfSubClient" header="#SubClient" sortable body={noOfSubClient} footer={() => {
                    const NOSubPv = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubClient || 0), 0);
                    return <span
                        onClick={() => setSubTable1({ open: true, resType: 3, totalRec: true })}
                        className="cursor-pointer text-cyan-700 underline">{NOSubPv}</span>;
                }} />
                <Column field="noOfSubRejSales" header="#SubRejSales" sortable body={noOfSubRejSales}
                    footer={() => {
                        const NOSubRejSales = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubRejSales || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 4, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{NOSubRejSales}</span>;
                    }}
                />
                <Column field="noOfSubRejPV" header="#SubRejPV" sortable body={noOfSubRejPV}
                    footer={() => {
                        const SubRejPV = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubRejPV || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 5, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{SubRejPV}</span>;
                    }} />

                <Column field="noOfSubRejClient" header="#SubRejClient" sortable body={noOfSubRejClient}
                    footer={() => {
                        const SubRejClient = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubRejClient || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 6, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{SubRejClient}</span>;
                    }} />
                <Column field="noOfECI" header="#ECI" sortable body={noOfECI}
                    footer={() => {
                        const ECI = tableData.tableData.reduce((sum, item) => sum + (item.noOfECI || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 7, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{ECI}</span>;
                    }} />
                <Column field="noStatusNotChange" header="#StatusNotChange" sortable body={noStatusNotChange}
                    footer={() => {
                        const noStatusNotChange = tableData.tableData.reduce((sum, item) => sum + (item.noStatusNotChange || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 8, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{noStatusNotChange}</span>;
                    }}
                />
                <Column field="noOfNoRoomECS" header="NoOfNoRoomECS" body={noRoomForECS} sortable
                    footer={() => {
                        const noOfNoRoomECS = tableData.tableData.reduce((sum, item) => sum + (item.noOfNoRoomECS || 0), 0);
                        return <span
                            className="text-black">{noOfNoRoomECS}</span>;
                    }} />
                <Column field="noOfReqHoldbyPV" header="NoOfReqHoldby PV" body={reqHoldByPV} sortable
                    footer={() => {
                        const noOfReqHoldbyPV = tableData.tableData.reduce((sum, item) => sum + (item.noOfReqHoldbyPV || 0), 0);
                        return <span
                            className="text-black">{noOfReqHoldbyPV}</span>;
                    }}
                />

            </DataTable>
            <SubTable open={subTable1.open} salesID={subTable1.salesID} resType={subTable1.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} totalRec={subTable1.totalRec} />
            <SubTableEfficiencyReport open={subTable.open} salesID={subTable.salesID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} totalRec={subTable.totalRec} />
            {/* {/ <Filter open={filter} hideDialog={hideFilterDialog} setSalEffFilter={setSalEffFilter} toast={toast} /> /} */}
            <Toast ref={toast} />
        </>
    );
}
